import Vue from 'vue'
// tslint:disable-next-line:no-import-side-effect
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)
Vue.use(require('vue-moment'))

Vue.config.productionTip = false

const requireComponent = require.context('./projectDetails', false, /[A-Z]\w+\.(vue|js)$/)
requireComponent.keys().map(f => {
  const componentConfig = requireComponent(f).default
  const projectKey = f.substring(2, f.indexOf('.', 2))
  Vue.component(projectKey, componentConfig)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
